// See NotificationCenterPage.spec.md for NCP-FR-002 and NCP-FR-003

import { getTimeRange, TIME_RANGES, type TimeRange } from 'core/components/widgets/timeRanges'

// NCP-FR-003: Timeframes offered on the Notification Center. 30 days is offered even
// though the audit service currently keeps about 7 days; it returns what the service still has.
export const TIMEFRAME_OPTIONS: TimeRange[] = [
  TIME_RANGES.last_1_hour,
  TIME_RANGES.last_3_hours,
  TIME_RANGES.last_6_hours,
  TIME_RANGES.last_12_hours,
  TIME_RANGES.last_24_hours,
  TIME_RANGES.last_7_days,
  TIME_RANGES.last_30_days,
]

export const DEFAULT_TIMEFRAME: TimeRange = TIME_RANGES.last_1_hour

// NCP-FR-002: The audit API takes the window as RFC3339 UTC timestamps
export const getTimeWindow = (timeframe: TimeRange, nowMs?: number) => {
  const { start, end } = getTimeRange(timeframe, nowMs)
  return {
    startTime: new Date(start * 1000).toISOString(),
    endTime: new Date(end * 1000).toISOString(),
  }
}
